import { HealthcareFacilityUnit, HealthcareFacilityUnitQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { paginations } from '@dreryk/command-query-ws-client';

import { statisticsTranslationKeys } from '../../translations';

type GenerateZD3FormLoaderRenderProps = {
   healthcareFacilityUnits: HealthcareFacilityUnit[];
};

type GenerateZD3FormLoaderProps = {
   readonly children: (renderProps: GenerateZD3FormLoaderRenderProps) => JSX.Element;
};

export const GenerateZD3FormLoader = (props: GenerateZD3FormLoaderProps): JSX.Element => {
   const {
      data: healthcareFacilityUnits,
      loading: healthcareFacilityUnitsLoading,
      error: healthcareFacilityUnitsError,
   } = useCqrsSearch<HealthcareFacilityUnit>(
      () => new HealthcareFacilityUnitQuery(),
      paginations.all<HealthcareFacilityUnit>()
   );

   if (healthcareFacilityUnitsLoading) {
      return <LoaderSpinner />;
   }

   if (healthcareFacilityUnitsError) {
      return (
         <Message
            testId={'failedToFetchHealthcareFacilityUnit'}
            label={statisticsTranslationKeys.zd3Form.failedToFetchHealthcareFacilityUnit}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      healthcareFacilityUnits: healthcareFacilityUnits,
   });
};
